<template>
  <v-container grid-list-xl>
    <v-layout wrap v-if="toolPickup">
      <v-flex xs12>
        <!-- back to pickups -->
        <v-btn
          class="mr-4 mb-2"
          small
          text
          color="primary"
          to="/tools/manage/pickups"
        >
          <v-icon small class="mr-1">chevron_left</v-icon>Pickups
        </v-btn>

        <!-- Submit Return order -->
        <v-dialog v-model="returnDialog" width="500">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="toolPickup.status == 'open'"
              small
              color="primary"
              dark
              class="mr-4 mb-2"
              v-on="on"
            >
              <v-icon small class="mr-2">assignment_turned_in</v-icon>Confirm
              Return
            </v-btn>
          </template>

          <v-card class="pa-4">
            <v-card-title class="title lighten-2" primary-title
              >Add Optional Note</v-card-title
            >

            <v-card-text>
              <v-simple-table class="my-4" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-center" width="80">Pickup</th>
                      <th class="text-center" width="160">Returned</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="t in toolPickup.tools.filter(
                        (t) => t.returnedQty > 0
                      )"
                      :key="t.id"
                    >
                      <td class="pl-0">
                        {{ t.title }}
                      </td>
                      <td class="text-center">{{ t.pickupQty }}</td>
                      <td class="text-center">{{ t.returnedQty }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <br />
              <v-textarea
                outlined
                label="Note for foreman."
                class="mt-4"
                v-model="returnNote"
                autofocus
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="returnDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" @click="confirmReturn">
                <v-icon small class="mr-2">assignment_turned_in</v-icon>Confirm
                Return</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- cancel order -->
        <v-dialog v-model="cancelPickupDialog" width="600">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="toolPickup.status == 'open'"
              dark
              small
              color="grey darken-2"
              class="mr-4 mb-2"
              v-on="on"
              @click="cancelPickupDialog = true"
            >
              <v-icon small class="mr-2">cancel</v-icon>Cancel Pickup
            </v-btn>
          </template>

          <v-card class="pa-4">
            <v-card-title class="title lighten-2" primary-title>
              Cancel Pickup
            </v-card-title>

            <v-card-text>
              Are you sure you want to cancel this pickup?
              <br />The foreman will be notified that the pickup was cancelled.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancelPickupDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" @click="cancelPickup">
                Cancel Pickup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- download pdf -->
        <v-btn
          class="float-right mb-2"
          small
          color="primary"
          @click="downloadPDF"
        >
          <v-icon small class="mr-1">picture_as_pdf</v-icon>Download PDF
        </v-btn>
      </v-flex>
      <!--  tool order details-->
      <v-flex xs12>
        <tool-pickup-details
          v-if="toolPickup"
          :toolPickup="toolPickup"
          :admin="true"
        />
      </v-flex>

      <!-- tool list -->
      <v-flex xs12>
        <v-card v-if="toolPickup">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left" width="100"></th>
                <th class="text-left">Name</th>
                <th class="text-center" width="80">On Site</th>
                <th class="text-center" width="80">Pickup</th>
                <th class="text-center" width="160">Returned</th>
                <th class="text-center" width="100"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tool in toolPickup.tools" :key="tool.id">
                <td class="pa-4">
                  <v-img :src="tool.image" width="50" height="50" contain />
                </td>
                <td>
                  {{ tool.title }}
                </td>
                <td class="text-center">
                  {{ tool.totalQty }}
                </td>
                <td class="text-center">
                  {{ tool.pickupQty }}
                </td>
                <td>
                  <div v-if="toolPickup.status !== 'open'" class="text-center">
                    {{ tool.returnedQty }}
                  </div>
                  <div v-else>
                    <v-icon
                      @click="tool.returnedQty--"
                      :disabled="tool.returnedQty <= 0"
                      >remove_circle_outline</v-icon
                    >
                    <v-text-field
                      class="d-inline-block ml-2 centered-input qty"
                      name="qty"
                      v-model.number="tool.returnedQty"
                      style="width:60px"
                      dense
                      type="number"
                      :rules="[
                        (v) =>
                          (v <= tool.totalQty && v >= 0 && !isNaN(v)) ||
                          'Invalid Qty',
                      ]"
                    ></v-text-field>
                    <v-icon
                      @click="tool.returnedQty++"
                      class="ml-2"
                      :disabled="tool.returnedQty >= tool.pickupQty"
                      >add_circle_outline</v-icon
                    >
                  </div>
                </td>
                <td>
                  <v-btn
                    color="primary"
                    text
                    outlined
                    small
                    v-if="toolPickup.status == 'open'"
                    @click="tool.returnedQty = tool.pickupQty"
                    >return all</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
          <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import toolPickupDetails from "@/components/toolPickups/ToolPickupDetails";
export default {
  components: {
    toolPickupDetails,
  },
  data() {
    return {
      search: "",
      snack: false,
      snackColor: "",
      snackText: "",
      toolPickup: null,
      returnDialog: false,
      cancelPickupDialog: false,
      returnNote: "",
    };
  },
  methods: {
    downloadPDF() {
      const url = `https://us-central1-alba-demolition.cloudfunctions.net/toolPickupGeneratePDF?orderNumber=${this.$route.params.orderNumber}`;
      window.open(url, "_blank");
    },
    async getOrder() {
      try {
        let toolPickup = await fb.db
          .collection("toolPickups")
          .doc(this.$route.params.orderNumber)
          .get();
        toolPickup = toolPickup.data();
        toolPickup.tools.forEach((tp) => {
          if (!tp.returnedQty) {
            tp.returnedQty = 0;
          }
        });
        this.toolPickup = toolPickup;
        console.log(this.toolPickup);
      } catch (error) {
        alert("Error getting orders.");
        console.log(error);
      }
    },
    async confirmReturn() {
      try {
        await fb.db
          .collection("toolPickups")
          .doc(this.$route.params.orderNumber)
          .update({
            status: "closed",
            closeDate: fb.timestamp,
            closedBy: this.user,
            tools: this.toolPickup.tools,
            returnNote: this.returnNote,
          });

        fb.db.collection("toolOrderEmails").add({
          type: "pickupConfirmed",
          closedBy: this.user,
          tools: this.toolPickup.tools,
          returnNote: this.returnNote,
          jobSite: this.toolPickup.jobSite,
          orderedBy: this.toolPickup.orderedBy,
          orderNumber: this.toolPickup.orderNumber,
        });
        this.returnDialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully confirmed return!";
        this.getOrder();
      } catch (error) {
        console.log(error);
        alert("Error updating order.");
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error confirming return!";
      }
    },
    async cancelPickup() {
      await fb.db
        .collection("toolPickups")
        .doc(this.$route.params.orderNumber)
        .update({
          status: "cancelled",
        });
      this.cancelPickupDialog = false;
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Successfully Cancelled Pickup!";
      this.getOrder();
    },
  },
  computed: {
    ...mapState(["user", "tools"]),
  },
  async created() {
    this.getOrder();
  },
};
</script>

<style scoped>
.fulfillment-input {
  margin-bottom: -20px;
}
</style>
